module.exports = __webpack_public_path__ + "media/images/noticias/viejas/pasajes-af6e393b42b00c8ec13dba41508a0afe.jpg";